export default "__VITE_ASSET__BNnVpGpU__"